// Schema de las 5 sedes (LocalBusiness + EducationalOrganization). Se inyecta SOLO donde se muestran las sedes: home y /centros (via Centers.jsx).
export const SEDES_SCHEMA = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": ["LocalBusiness", "EducationalOrganization"],
      "@id": "https://autoescuelasfaro.com/autoescuela-plaza-america#business",
      "name": "Autoescuelas Faro - Plaza América",
      "url": "https://autoescuelasfaro.com/autoescuela-plaza-america",
      "telephone": "+34986292455",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Centro Comercial 3 Plaza América, Local 12",
        "postalCode": "36211",
        "addressLocality": "Vigo",
        "addressRegion": "Pontevedra",
        "addressCountry": "ES"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 42.225,
        "longitude": -8.736
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday"
          ],
          "opens": "10:00",
          "closes": "13:30"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday"
          ],
          "opens": "16:30",
          "closes": "20:00"
        }
      ],
      "areaServed": [
        "Vigo",
        "As Travesas",
        "Balaídos",
        "Coia",
        "O Porriño",
        "Redondela"
      ],
      "sameAs": [
        "https://www.instagram.com/autoescuelasfaro/",
        "https://www.facebook.com/autoescuelasfaro/"
      ],
      "parentOrganization": {
        "@type": "Organization",
        "name": "Autoescuelas Faro",
        "url": "https://autoescuelasfaro.com"
      }
    },
    {
      "@type": ["LocalBusiness", "EducationalOrganization"],
      "@id": "https://autoescuelasfaro.com/autoescuela-coruxo#business",
      "name": "Autoescuelas Faro - Coruxo",
      "url": "https://autoescuelasfaro.com/autoescuela-coruxo",
      "telephone": "+34986236265",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Estrada Camposancos, 202",
        "postalCode": "36330",
        "addressLocality": "Vigo",
        "addressRegion": "Pontevedra",
        "addressCountry": "ES"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 42.190333,
        "longitude": -8.789444
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday"
          ],
          "opens": "09:30",
          "closes": "13:30"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday"
          ],
          "opens": "17:00",
          "closes": "20:00"
        }
      ],
      "areaServed": [
        "Coruxo",
        "Oia",
        "Saiáns",
        "Vigo"
      ],
      "sameAs": [
        "https://www.instagram.com/autoescuelasfaro/",
        "https://www.facebook.com/autoescuelasfaro/"
      ],
      "parentOrganization": {
        "@type": "Organization",
        "name": "Autoescuelas Faro",
        "url": "https://autoescuelasfaro.com"
      }
    },
    {
      "@type": ["LocalBusiness", "EducationalOrganization"],
      "@id": "https://autoescuelasfaro.com/autoescuela-panxon#business",
      "name": "Autoescuelas Faro - Panxón",
      "url": "https://autoescuelasfaro.com/autoescuela-panxon",
      "telephone": "+34986366651",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Praza Jesús Espinosa, 1",
        "postalCode": "36340",
        "addressLocality": "Nigrán",
        "addressRegion": "Pontevedra",
        "addressCountry": "ES"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 42.149444,
        "longitude": -8.823333
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday"
          ],
          "opens": "10:00",
          "closes": "13:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday"
          ],
          "opens": "16:30",
          "closes": "19:30"
        }
      ],
      "areaServed": [
        "Panxón",
        "Praia América",
        "Val Miñor",
        "Nigrán",
        "Baiona"
      ],
      "sameAs": [
        "https://www.instagram.com/autoescuelasfaro/",
        "https://www.facebook.com/autoescuelasfaro/"
      ],
      "parentOrganization": {
        "@type": "Organization",
        "name": "Autoescuelas Faro",
        "url": "https://autoescuelasfaro.com"
      }
    },
    {
      "@type": ["LocalBusiness", "EducationalOrganization"],
      "@id": "https://autoescuelasfaro.com/autoescuela-nigran#business",
      "name": "Autoescuelas Faro - Nigrán",
      "url": "https://autoescuelasfaro.com/autoescuela-nigran",
      "telephone": "+34986368424",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Rúa Canido, 2",
        "postalCode": "36350",
        "addressLocality": "Nigrán",
        "addressRegion": "Pontevedra",
        "addressCountry": "ES"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 42.150972,
        "longitude": -8.795278
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday"
          ],
          "opens": "10:00",
          "closes": "13:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday"
          ],
          "opens": "16:30",
          "closes": "19:30"
        }
      ],
      "areaServed": [
        "Nigrán",
        "Val Miñor",
        "Gondomar",
        "Baiona"
      ],
      "sameAs": [
        "https://www.instagram.com/autoescuelasfaro/",
        "https://www.facebook.com/autoescuelasfaro/"
      ],
      "parentOrganization": {
        "@type": "Organization",
        "name": "Autoescuelas Faro",
        "url": "https://autoescuelasfaro.com"
      }
    },
    {
      "@type": ["LocalBusiness", "EducationalOrganization"],
      "@id": "https://autoescuelasfaro.com/autoescuela-a-caniza#business",
      "name": "Autoescuelas Faro - A Cañiza",
      "url": "https://autoescuelasfaro.com/autoescuela-a-caniza",
      "telephone": "+34986651329",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "C/ Villanueva, 20",
        "postalCode": "36880",
        "addressLocality": "A Cañiza",
        "addressRegion": "Pontevedra",
        "addressCountry": "ES"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 42.21,
        "longitude": -8.27
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday"
          ],
          "opens": "10:00",
          "closes": "13:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday"
          ],
          "opens": "17:00",
          "closes": "20:00"
        }
      ],
      "areaServed": [
        "A Cañiza",
        "O Covelo",
        "Arbo",
        "Crecente"
      ],
      "sameAs": [
        "https://www.instagram.com/autoescuelasfaro/",
        "https://www.facebook.com/autoescuelasfaro/"
      ],
      "parentOrganization": {
        "@type": "Organization",
        "name": "Autoescuelas Faro",
        "url": "https://autoescuelasfaro.com"
      }
    }
  ]
};
